/**
 * ============================================================================
 * BAMBOOVE — THANH MUA DÍNH ĐÁY (kiểu Volume) + NÚT VỀ ĐẦU TRANG
 * (16/10/2026 · phiên 75g) · File MỚI — không đụng bamboove-pdp.js;
 * chỉ NGHE sự kiện `bb:pdp-cap-nhat` do bamboove-pdp.js bắn ra:
 *   detail = { id, conHang, color, size, gia }   (gia = giá theo mức mua đang chọn)
 * ----------------------------------------------------------------------------
 * • Hiện khi nút Add to bag KHUẤT HẲN (atc.bottom < 0) — như Volume (đo thật);
 *   ẩn lại khi cuộn lên thấy nút, khi SP hết hàng, hoặc khi CHÂN TRANG vào màn hình.
 * • Đổi màu/cỡ/gói ⇒ thanh tự cập nhật: giá · số đôi · dòng "Màu / Cỡ" · ảnh nhỏ.
 * • Bấm CHANGE (hoặc bấm nút giỏ khi CHƯA chọn cỡ) ⇒ cuộn lên khu chọn + nháy viền
 *   ⇒ KHÔNG cho thêm giỏ khi thiếu cỡ (nút không bị mờ khó hiểu như bản cũ).
 * • Nút ↑ về đầu trang: hiện sau ~1,2 màn hình; khi thanh mua đang hiện thì tự nhô
 *   lên nằm TRÊN thanh (biến --bb-sticky-h) — không bao giờ đè nhau.
 * Hỗ trợ cả 2 kiểu cuộn của theme: window và .page-wrapper (sự kiện không bong bóng).
 * ============================================================================
 */
(function () {
  'use strict';

  var goc = document.querySelector('[data-bb-pdp]');
  if (!goc) return;
  var thanh = goc.querySelector('[data-bb-sticky]');
  var atcBtn = goc.querySelector('[data-bb-atc]');
  if (!thanh || !atcBtn || thanh.dataset.bbSaReady === '1') return;
  thanh.dataset.bbSaReady = '1';

  var img = thanh.querySelector('[data-bb-sticky-img]');
  var giaEl = thanh.querySelector('[data-bb-sticky-price]');
  var qtyEl = thanh.querySelector('[data-bb-sticky-qty]');
  var bien = thanh.querySelector('[data-bb-sticky-bien]');
  var bienChu = thanh.querySelector('[data-bb-sticky-chon]');
  var nutDoi = thanh.querySelector('[data-bb-sticky-change]');
  var nutGio = thanh.querySelector('[data-bb-sticky-btn]');
  var nutLen = goc.querySelector('[data-bb-lendau]');
  var tenMau = goc.querySelector('[data-bb-color-name]');
  var doiDuoc = thanh.getAttribute('data-co-doi') === '1';
  var khoiCo = goc.querySelector('.bb-pdp__sizes');
  var khoiChon = khoiCo ? khoiCo.closest('.bb-pdp__opt') : goc.querySelector('.bb-pdp__opt');

  /* ---------- đọc/ghi vị trí cuộn: hỗ trợ cả window lẫn .page-wrapper ---------- */
  function vungCuon() {
    var w = document.querySelector('.page-wrapper');
    return (w && w.scrollHeight > w.clientHeight + 5) ? w : null;
  }
  function yCuon() {
    var w = vungCuon();
    return w ? w.scrollTop : (window.scrollY || document.documentElement.scrollTop || 0);
  }
  function cuonToi(y) {
    var w = vungCuon();
    if (w) { w.scrollTo({ top: y, behavior: 'smooth' }); }
    else { window.scrollTo({ top: y, behavior: 'smooth' }); }
  }

  /* ---------- SP còn hàng? (đọc từ JSON giá do Liquid đổ ra) ---------- */
  var conHang = true;
  try {
    var bang = JSON.parse((goc.querySelector('[data-bb-prices]') || {}).textContent || '{}');
    var vIn = goc.querySelector('[data-bb-variant]');
    if (vIn && bang[vIn.value]) conHang = !!bang[vIn.value].a;
  } catch (e) { /* giữ mặc định */ }

  /* ---------- A. HIỆN / ẨN THEO CUỘN + CHÂN TRANG ---------- */
  var dangHien = false;
  var chanTrongTam = false;
  var chan = document.querySelector('[id*="__footer"], footer');
  if (chan && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (en) { chanTrongTam = en.isIntersecting; });
      xepLai();
    }, { threshold: 0 }).observe(chan);
  }

  function xepLai() {
    var hien = conHang && atcBtn.getBoundingClientRect().bottom < 0 && !chanTrongTam;
    if (hien !== dangHien) {
      dangHien = hien;
      thanh.classList.toggle('is-show', hien);
    }
    document.documentElement.style.setProperty('--bb-sticky-h', dangHien ? thanh.offsetHeight + 'px' : '0px');
    if (nutLen) {
      var vh = window.innerHeight || 1;
      nutLen.classList.toggle('is-show', yCuon() > vh * 1.2);
    }
  }

  var choRaf = false;
  function nhe() {
    if (choRaf) return;
    choRaf = true;
    (window.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(function () {
      choRaf = false;
      xepLai();
    });
  }
  /* capture:true ⇒ bắt được cả cuộn bên trong .page-wrapper (sự kiện scroll không bong bóng) */
  window.addEventListener('scroll', nhe, { passive: true, capture: true });
  window.addEventListener('resize', nhe, { passive: true });

  /* ---------- B. CẬP NHẬT NỘI DUNG THANH (giá · số đôi · "Màu / Cỡ" · ảnh nhỏ) ---------- */
  function capNhatThanh(d) {
    if (d && d.gia !== undefined) {
      if (giaEl) giaEl.textContent = d.gia || '';
    } else if (giaEl) {
      var t0 = goc.querySelector('[data-bb-tier].is-active');
      var p0 = t0 ? t0.querySelector('.bb-pdp__tier-price') : null;
      if (p0) giaEl.textContent = p0.textContent.replace(/\s+/g, ' ').trim();
    }
    if (d && d.conHang !== undefined) conHang = !!d.conHang;

    if (qtyEl) {
      var t = goc.querySelector('[data-bb-tier].is-active');
      var n = t ? (parseInt(t.getAttribute('data-bb-tier'), 10) || 0) : 0;
      qtyEl.textContent = n ? (n + ' pair' + (n > 1 ? 's' : '')) : '';
    }

    if (bien && doiDuoc) {
      var phan = [];
      if (tenMau && tenMau.textContent.trim()) phan.push(tenMau.textContent.trim());
      var coChon = goc.querySelector('.bb-pdp__size.is-active');
      if (coChon) phan.push(coChon.textContent.trim());
      var chu = phan.join(' / ');
      if (!chu && khoiCo) chu = 'Choose a size';
      if (bienChu) bienChu.textContent = chu;
    }

    if (img) {
      var nguon = goc.querySelector('[data-bb-thumb].is-active img') || goc.querySelector('[data-bb-slide] img');
      if (nguon && nguon.src && img.src !== nguon.src) img.src = nguon.src;
    }

    nhe();
  }
  document.addEventListener('bb:pdp-cap-nhat', function (e) { capNhatThanh(e.detail || {}); });

  /* ---------- C. CHANGE / bấm giỏ khi CHƯA chọn cỡ ⇒ cuộn lên + nháy ---------- */
  function cuonLenChon() {
    var dich = khoiChon;
    if (!dich) { cuonToi(0); return; }
    var r = dich.getBoundingClientRect();
    var vh = window.innerHeight || 1;
    cuonToi(Math.max(0, yCuon() + r.top - Math.min(vh * 0.28, 260)));
    dich.classList.remove('is-nhay');
    void dich.offsetWidth;               /* ép trình duyệt vẽ lại ⇒ chạy lại hoạt ảnh */
    dich.classList.add('is-nhay');
    window.setTimeout(function () { dich.classList.remove('is-nhay'); }, 1900);
  }
  if (nutDoi) nutDoi.addEventListener('click', function (e) { e.preventDefault(); cuonLenChon(); });
  if (nutGio) {
    nutGio.addEventListener('click', function (e) {
      if (khoiCo && !goc.querySelector('.bb-pdp__size.is-active')) {
        e.preventDefault();              /* chưa chọn cỡ ⇒ KHÔNG thêm giỏ, kéo lên chỗ chọn */
        cuonLenChon();
      }
    });
  }

  /* ---------- D. NÚT ↑ VỀ ĐẦU TRANG ---------- */
  if (nutLen) nutLen.addEventListener('click', function () { cuonToi(0); });

  /* ---------- chạy lần đầu (đúng cả khi mở trang đã ở vị trí cuộn sẵn) ---------- */
  capNhatThanh(null);
  xepLai();
})();
